import { NativeBridge } from "@swiggy-private/native-bridge";

let bridgeSdk: NativeBridge | null = null;

export const initBridgeSdk = (sdk?: NativeBridge): NativeBridge => {
    if (bridgeSdk && !sdk) {
        return bridgeSdk;
    }

    bridgeSdk = sdk || new NativeBridge(null);
    return bridgeSdk;
};

/**
 * get instance for bridge sdk via getBridgeSdk
 * @returns instance for bridge SDK
 */
export const getBridgeSdk = (): NativeBridge => bridgeSdk || initBridgeSdk();

export const isBrowserEnv = () => typeof window !== "undefined";

export const closeWebview = () => {
    const sdk = getBridgeSdk();
    if (sdk?.close) {
        return sdk.close().catch(() => void 0);
    } else {
        window.location.href = "/";
    }
};
